export default "__VITE_ASSET__1489af2b__"